import styled from 'styled-components'
import { getWeight, getSize, getTransform } from './TextVariants'
import { TextStyleProps } from './types'
import { tokens } from '../theme'
const { color, font, space } = tokens

export const Text = styled.p<TextStyleProps>`
  margin: ${(p) => p.margin};
  padding: ${(p) => p.padding};
  color: ${(p) => color.text[p.color]};
  font-family: ${(p) => font.family[p.family]};
  text-align: ${(p) => p.align};
  line-height: ${(p) => p.lineHeight || font.lineHeight.lg};
  ${(p) => getWeight[p.weight]}
  ${(p) => getSize[p.size]}
  ${(p) => getTransform[p.transform]}
  ${(p) => p.underline && 'text-decoration: underline;'}
  ${(p) => p.italic && 'font-style: italic;'}
  ${(p) =>
    p.ellipsis
      ? `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `
      : ` white-space: break-spaces;`}

  & > svg,
  & > .icon {
    margin-right: ${space.xs2};
  }

  & > svg {
    vertical-align: middle;
  }
`
